module.exports = __webpack_public_path__ + "a95741184a4e46fb8bb5af6289d6b741.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_22.jpg
// module id = 1737
// module chunks = 5